import { type BlogCategory } from '#test/__generated__/api.js';

export const getCategoryAsPath = (category: string) => {
  return category
    .toLowerCase()
    .replaceAll(' ', '-')
    .replaceAll(',', '')
    .replaceAll('&', 'and');
};

export const getCategoryHref = ({
  displayUsername,
  id,
  name,
}: BlogCategory & {
  displayUsername: string;
}) => {
  return id === 'all'
    ? `${displayUsername}/`
    : `/${displayUsername}/${getCategoryAsPath(name)}`;
};
